import { state } from "../store"

export default {
  validFunctionNames: [
    "updateDevices",
    "updateMeals",
    "updateOffers",
    "updateScheduling",
    "updateProjectCurrency",
    "updateProjectDefaultImage",
    "updateSchedulingConf",
    "updateProjectHours",
    "updateScreens"
  ],

  cachedFunctions: [],

  isProjectConsistent() {
    return this.validFunctionNames.length === this.cachedFunctions.length
  },

  registerCall(functionName) {
    if (
      !this.cachedFunctions.includes(functionName) &&
      this.validFunctionNames.includes(functionName)
    ) {
      this.cachedFunctions.push(functionName)
    }
  },

  saveProjectToCache() {
    localStorage.setItem("project", JSON.stringify(state.project))
  },

  getProjectDataFromCache() {
    const projectStr = localStorage.getItem("project")
    if (projectStr == null) {
      throw Error("No project in cache")
    }
    return JSON.parse(projectStr)
  },

  callAndCache(fn) {
    const me = this
    return function() {
      const res = fn.apply(me, arguments)
      me.registerCall(fn.name)
      if (me.isProjectConsistent()) {
        me.saveProjectToCache()
      }
      return res
    }
  }
}
